import { IApi, Api } from "../../utilities/Api";
import * as ACTIONCONTANTS from "./ActionConstants";
import { ApiRequest } from "../../utilities/ApiRequest";
import LMSDispatcher from "../LMSDispatcher";
import BackupViewData, { IBackupViewData } from "../../models/BackupAndRestore/BackupViewData";
import i18next from "i18next";


class BackupAndRestoreActions {
    private readonly api: IApi;

    constructor() {
        this.api = new Api(ACTIONCONTANTS.SAMPLE_ENDPOINT)
    }

    async getAll(createdDate: string) {
        try {
            const request = new ApiRequest("/BackupRestore/GetBackupFiles/"+ createdDate, "", null, i18next.t("Unable to fetch backup files."));
            const result = await this.api.get(request);
            const payload = this.convertResponseListData(result.data);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.BACKUP_AND_RESTORE_GET_ALL,
                payload: {
                    data: payload
                }
            });
        } catch (error) {
            throw error;
        }
    }

    async post(prefix: string): Promise<void> {
        try {
            const request = new ApiRequest("/BackupRestore/Backup/" + prefix, "", null, i18next.t("Backup created."));
            const result = await this.api.post(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.BACKUP_AND_RESTORE_GET_ALL,
                payload: {
                    reload: true,
                    message: result.message
                }
            })
        } catch (error) {
            throw error;
        }
    }

    async restoreBackup(location: string): Promise<void> {
        try {
            const request = new ApiRequest("/BackupRestore/Restore/?location=" + location, "", undefined, i18next.t("Backup restored."));
            const result = await this.api.post(request);
            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.RESTORE_BACKUP,
                payload: {
                    reload: false,
                    message: result.message
                }
            })
        } catch (error) {
            throw error;
        }
    }

    private convertResponseListData(data: any): IBackupViewData[] {
        const result: IBackupViewData[] = [];

        data.forEach((element: { id: string; name: string; size: string; date: string, time: string; status: string, dateTime: string, service: number }) => {
            result.push(new BackupViewData(element.id, element.name, element.size, element.date, element.time, element.status, element.dateTime, element.service));
        });
        return result;
    }

    async deleteBackup(backupNames: Array<string>): Promise<void> {
        try {
            const payload: any = backupNames;
            const request = new ApiRequest("/BackupRestore/Delete", "", payload, i18next.t("Backup deleted."));
            const result = await this.api.deleteAll(request);

            LMSDispatcher.dispatch({
                type: ACTIONCONTANTS.BACKUP_AND_RESTORE_GET_ALL,
                payload: {
                    reload: true,
                    message: result.message
                }
            });

        } catch (error) {
            throw error;
        }
    }
}

const backupAndRestoreActions = new BackupAndRestoreActions();
export default backupAndRestoreActions;